var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "skill-plaza"
  }, [_c("section", {
    staticClass: "plaza-banner",
    style: {
      background: `url(${_vm.bannerImg}) no-repeat center right`,
      backgroundSize: "cover"
    }
  }, [_c("div", {
    staticClass: "section-main banner-container"
  }, [_c("div", {
    staticClass: "banner-content"
  }, [_vm._m(0), _c("p", {
    staticClass: "banner-desc"
  }, [_vm._v(" 依托同花顺覆盖全市场的权威数据资源与成熟的金融分析体系，Skill 将专业能力模块化、产品化输出，帮助用户以更低门槛获取机构级投研能力，让一次经验、转化为可持续复用与进化的智能资产。 ")]), _c("div", {
    staticClass: "btn-group"
  }, [_c("button", {
    staticClass: "btn-primary",
    on: {
      click: _vm.handleTrial
    }
  }, [_vm._v("立即试用")])])])])]), _c("section", {
    staticClass: "plaza-advantages"
  }, [_c("div", {
    staticClass: "section-main"
  }, [_vm._m(1), _c("div", {
    staticClass: "advantages-cards"
  }, _vm._l(_vm.advantagesData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "adv-card"
    }, [_c("h3", {
      staticClass: "card-title",
      domProps: {
        innerHTML: _vm._s(item.title)
      }
    }), _c("p", {
      staticClass: "card-desc"
    }, [_vm._v(_vm._s(item.desc))]), _c("div", {
      staticClass: "card-img-wrap"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "advantage icon"
      }
    })])]);
  }), 0)])]), _c("section", {
    staticClass: "plaza-categories"
  }, [_c("div", {
    staticClass: "section-main"
  }, [_vm._m(2), _c("div", {
    staticClass: "tabs-container"
  }, [_c("div", {
    staticClass: "tabs-header"
  }, _vm._l(_vm.tabsData, function (tab, index) {
    return _c("div", {
      key: index,
      staticClass: "tab-item",
      class: [{
        active: _vm.activeTabIndex === index
      }, _vm.activeTabIndex === index && index === 0 ? "active-first" : ""],
      on: {
        click: function ($event) {
          return _vm.handleTabClick(index);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.name) + " ")]);
  }), 0), _c("div", {
    staticClass: "tab-desc-bar",
    class: "active-index-" + _vm.activeTabIndex
  }, [_vm._v(" " + _vm._s(_vm.tabsData[_vm.activeTabIndex].desc) + " ")])]), _vm.pagedCards.length > 0 ? _c("div", {
    staticClass: "skill-card-grid"
  }, _vm._l(_vm.pagedCards, function (card, index) {
    return _c("div", {
      key: index,
      staticClass: "skill-card",
      on: {
        click: function ($event) {
          return _vm.handleCardClick(card);
        }
      }
    }, [_c("div", {
      staticClass: "card-header"
    }, [_c("div", {
      staticClass: "avatar",
      style: _vm.getAvatarProps(card.name).style
    }, [_vm._v(" " + _vm._s(_vm.getAvatarProps(card.name).char) + " ")]), _c("div", {
      staticClass: "info"
    }, [_c("h4", {
      staticClass: "name"
    }, [_vm._v(_vm._s(card.name))]), _c("span", {
      staticClass: "author"
    }, [_vm._v(_vm._s(card.author))])])]), _c("div", {
      staticClass: "card-body"
    }, [_vm._v(" " + _vm._s(card.desc) + " ")]), _c("div", {
      staticClass: "card-tag"
    }, [_vm._v(" 交流工具 ")])]);
  }), 0) : !_vm.loading ? _c("div", {
    staticClass: "empty-container"
  }, [_c("a-empty", {
    attrs: {
      description: "暂无相关技能实例"
    }
  })], 1) : _vm._e(), _vm.total > 0 ? _c("div", {
    staticClass: "pagination-container"
  }, [_c("span", {
    staticClass: "page-info"
  }, [_vm._v(_vm._s(_vm.startIndex) + "-" + _vm._s(_vm.endIndex) + " / " + _vm._s(_vm.total))]), _c("button", {
    staticClass: "page-btn",
    attrs: {
      disabled: _vm.currentPage === 1
    },
    on: {
      click: function ($event) {
        return _vm.handlePageChange(_vm.currentPage - 1);
      }
    }
  }, [_vm._v(" < ")]), _c("div", {
    staticClass: "page-numbers"
  }, _vm._l(_vm.totalPages, function (page) {
    return _c("span", {
      key: page,
      staticClass: "page-num",
      class: {
        active: _vm.currentPage === page
      },
      on: {
        click: function ($event) {
          return _vm.handlePageChange(page);
        }
      }
    }, [_vm._v(" " + _vm._s(page) + " ")]);
  }), 0), _c("button", {
    staticClass: "page-btn",
    attrs: {
      disabled: _vm.currentPage === _vm.totalPages
    },
    on: {
      click: function ($event) {
        return _vm.handlePageChange(_vm.currentPage + 1);
      }
    }
  }, [_vm._v(" > ")])]) : _vm._e()])]), _c("a-modal", {
    attrs: {
      wrapClassName: "skill-custom-modal",
      title: _vm.currentCard.name,
      centered: "",
      width: 600,
      maskClosable: true
    },
    model: {
      value: _vm.modalVisible,
      callback: function ($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c("div", {
    staticClass: "modal-detail-content",
    staticStyle: {
      padding: "12px 0",
      "font-size": "14px",
      color: "#666",
      "line-height": "1.8",
      "word-break": "break-all"
    }
  }, [_vm._v(" " + _vm._s(_vm.currentCard.desc) + " ")]), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    key: "back",
    on: {
      click: function ($event) {
        _vm.modalVisible = false;
      }
    }
  }, [_vm._v(" 取消 ")]), _c("a-button", {
    key: "submit",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleModalTrial
    }
  }, [_vm._v(" 立即试用 ")])], 1)], 2)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("h1", {
    staticClass: "banner-title"
  }, [_c("span", {
    staticClass: "highlight-text"
  }, [_vm._v("SKILL广场")]), _vm._v(" 让专业能力，不再依赖人，而是随时调用 ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-title"
  }, [_c("h2", [_vm._v("产品优势")]), _c("span", {
    staticClass: "en-title"
  }, [_vm._v("Advantages")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-title"
  }, [_c("h2", [_vm._v("分类")]), _c("span", {
    staticClass: "en-title"
  }, [_vm._v("Categories")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };